let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9VgeF")).then(() => parcelRequire('a4zvS'));